import allFlowsContactInfoUpdateTemplate from "../core/allFlowsContactInfoUpdateTemplate";

const contactInfoTemplate = ` 
    ${allFlowsContactInfoUpdateTemplate}
`;
export default contactInfoTemplate;
